import { client } from '../default.client';

export const smartLock = {
	async unlock(terminal_id: number) {
		const res = await client.post('/smart-lock/v1/open-lock', { terminal_id });
		return res.data;
	}
};
